/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-floating-promises */
// TODO: look into these floating promises
import React from 'react';
import { NavigationState, NavigationStat, NavigationStatType } from '.';
import { Stack, getTheme, Text, FontIcon, SpinnerSize, Spinner, PersonaSize } from '@fluentui/react';
import './NavigationCard.scss';
import { NavigationCardLinks } from './NavigationCardLinks';
import { QueueConfiguration, getQueueStats, QueueStats } from 'services';
import { FacepileList } from '../../dashboard/card/FacepileList';

export interface NavigationCardProps {
  key: string;
  displayName: string;
  navigationState: NavigationState;
  config: QueueConfiguration;
  onNavigationClick(target: NavigationState): void;
}

interface NavigationCardState {
  stats: QueueStats | undefined;
}

const queueStatsPollingIntervalInMilliseconds = 10000;

export class NavigationCard extends React.PureComponent<NavigationCardProps, NavigationCardState> {
  private queueStatsApiIsRunning: boolean;
  private setIntervalId: number;

  constructor(props) {
    super(props);
    this.queueStatsApiIsRunning = false;
    this.setIntervalId = 0;
    this.state = {
      stats: undefined
    };
  }

  // API Call to GMC to get the Stats for Each Queue
  componentDidMount(): void {
    // Create func variable so function can be called before setInterval polling starts
    const getQueueStatsFunc = async (): Promise<void> => {
      // Don't make api call if waiting for another api call to finish
      if (this.queueStatsApiIsRunning) {
        return;
      } else {
        // Change status to running before making api call
        this.queueStatsApiIsRunning = true;
        try {
          const stats = await getQueueStats(this.props.config);
          // Change status to not running after api call complete
          this.queueStatsApiIsRunning = false;

          this.setState({
            stats
          });
        } catch (error) {
          this.queueStatsApiIsRunning = false;
        }
      }
    };

    // Initial call
    getQueueStatsFunc();

    // Run set interval to poll queue stats
    this.setIntervalId = window.setInterval(getQueueStatsFunc, queueStatsPollingIntervalInMilliseconds);
  }

  // Stops setInterval from running when component is unmounted
  componentWillUnmount(): void {
    clearInterval(this.setIntervalId);
  }

  render(): JSX.Element {
    const { palette } = getTheme();

    const cardClass: string =
      this.props.navigationState !== NavigationState.NONE ? 'navigation-card-selected' : 'navigation-card';
    const stackStyles = {
      root: [
        {
          backgroundColor: this.props.navigationState === NavigationState.REVIEW ? palette.white : palette.neutralLight,
          borderStyle: 'solid',
          borderBottomColor: palette.neutralQuaternaryAlt,
          borderWidth: '0px 0px 1px 0px'
        },
        {
          selectors: {
            ':before': {
              background: palette.themePrimary
            }
          }
        }
      ]
    };

    return (
      <Stack horizontal styles={stackStyles} className={cardClass}>
        <Stack.Item grow className="pl-2">
          <Stack horizontal>
            <Stack.Item align="center" className="mr-2">
              <FontIcon iconName="LocationCircle" />
            </Stack.Item>
            <Stack.Item>
              <Text variant="mediumPlus">{this.props.displayName}</Text>
            </Stack.Item>
          </Stack>
          {this.state.stats && (
            <Stack.Item>
              <Stack>
                <Stack.Item className="pt-1">
                  <FacepileList userList={this.state.stats.moderatorsAssigned} personaSize={PersonaSize.size24} />
                </Stack.Item>
                <Stack.Item>
                  <Stack horizontal className="pl-2" styles={{ root: { position: 'absolute', bottom: '0' } }}>
                    <NavigationStat
                      displayName="Open"
                      enableLeftBorder={false}
                      statsType={NavigationStatType.default}
                      value={this.state.stats.casesTotal}
                      tooltipText="Total number of currently open cases in this moderation queue needing moderator feedback."
                    />
                    <NavigationStat
                      displayName="Near SLA"
                      enableLeftBorder={true}
                      value={this.state.stats.casesTotalNearingCaseOpenLifetime}
                      statsType={NavigationStatType.default}
                      tooltipText="Number of open cases that are nearing the given SLA deadline."
                    />
                    <NavigationStat
                      displayName="Past SLA"
                      enableLeftBorder={true}
                      value={this.state.stats.casesTotalExceedingCaseOpenLifetime}
                      statsType={NavigationStatType.error}
                      tooltipText="Number of open cases that have been in an open state longer than the given SLA."
                    />
                  </Stack>
                </Stack.Item>
              </Stack>
            </Stack.Item>
          )}
          {!this.state.stats && (
            <Stack.Item>
              <Spinner className="py-4" size={SpinnerSize.medium} />
            </Stack.Item>
          )}
        </Stack.Item>
        <Stack.Item>
          <NavigationCardLinks
            iconState={this.props.navigationState}
            onNavigationClick={this.props.onNavigationClick}
          />
        </Stack.Item>
      </Stack>
    );
  }
}

export default NavigationCard;
